import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { StudentListItem, Student } from './StudentListItem';

interface StudentsListProps {
  students: Student[];
  search: string;
  onSearchChange: (value: string) => void;
  onStudentClick: (student: Student) => void;
  onStudentDelete: (studentId: string) => void;
  selectedStudentId?: string;
}

export const StudentsList: React.FC<StudentsListProps> = ({
  students,
  search,
  onSearchChange,
  onStudentClick,
  onStudentDelete,
  selectedStudentId
}) => {
  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <SearchIcon className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Поиск по ФИО или Email..."
          className="w-full rounded-md border-gray-300 bg-white py-2 pl-10 pr-10 shadow-sm"
        />
        {search && (
          <button
            type="button"
            onClick={() => onSearchChange("")}
            className="absolute inset-y-0 right-0 flex items-center pr-3"
            aria-label="Очистить"
          >
            <ClearIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
          </button>
        )}
      </div>

      <div className="space-y-3">
        {students.length === 0 ? (
          <div className="rounded-lg border-2 border-dashed border-gray-300 p-12 text-center text-gray-500">
            <h3 className="text-lg font-medium">
              {search ? "Ничего не найдено" : "Список студентов пуст"}
            </h3>
            <p className="mt-1 text-sm">
              {search
                ? "Попробуйте изменить поисковый запрос."
                : "Нажмите 'Добавить студента', чтобы создать первого."}
            </p>
          </div>
        ) : (
          students.map((student) => (
            <StudentListItem
              key={student.id}
              student={student}
              onClick={() => onStudentClick(student)}
              onDelete={() => onStudentDelete(student.id)}
              isSelected={selectedStudentId === student.id}
            />
          ))
        )}
      </div>
    </div>
  );
};